// Vendorizado de @lai/capability-registry (view-model.ts) — lógica anti-BOTÃO-FALSO intacta.
// capability -> estado de UI. Ação só HABILITA com backend real.
import { CapabilityRegistry, type Capability } from "./capability.js";
import i18n from "./i18n.js";

export interface ActionView {
  capabilityId: string;
  title: string;
  surfaceOwner: string;
  enabled: boolean; // true SÓ se backend real pronto
  disabledReason: string | null; // motivo honesto quando desabilitado
  httpHint: 200 | 403 | 501; // 200 ok | 403 policy | 501 backend ausente (NUNCA 404/500, nunca botão morto)
}

function reasonFor(c: Capability): {
  enabled: boolean;
  reason: string | null;
  hint: 200 | 403 | 501;
} {
  if (c.requires_hitl)
    return { enabled: false, reason: i18n.t("controlDesk.humanDecision"), hint: 403 };
  if (c.status === "READY_BACKEND" || c.status === "READY")
    return { enabled: true, reason: null, hint: 200 };
  if (c.external_ci_required)
    return { enabled: false, reason: i18n.t("controlDesk.externalPending"), hint: 501 };
  // contract-only / needs-backend -> backend ausente => 501 honesto, botão desabilitado com motivo
  return {
    enabled: false,
    reason: i18n.t("controlDesk.backendUnavailable", { status: c.status }),
    hint: 501,
  };
}

// Constrói o view-model de todas as ações; opcionalmente filtra por surface (CONNECT_SELLER, LAI_DISK_ADMIN, ...).
export function buildActionViews(reg: CapabilityRegistry, surfaceOwner?: string): ActionView[] {
  return reg
    .list()
    .map((row) => reg.get(row.capability_id))
    .filter((c): c is Capability => c !== null)
    .filter((c) => !surfaceOwner || c.surface_owner === surfaceOwner)
    .map((c) => {
      const r = reasonFor(c);
      return {
        capabilityId: c.id,
        title: c.title,
        surfaceOwner: c.surface_owner,
        enabled: r.enabled,
        disabledReason: r.reason,
        httpHint: r.hint,
      };
    });
}
